"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkTheme = exports.lightTheme = exports.typography = exports.colors = void 0;
var js_1 = require("./js");
Object.defineProperty(exports, "colors", { enumerable: true, get: function () { return js_1.colors; } });
Object.defineProperty(exports, "typography", { enumerable: true, get: function () { return js_1.typography; } });
Object.defineProperty(exports, "lightTheme", { enumerable: true, get: function () { return js_1.lightTheme; } });
Object.defineProperty(exports, "darkTheme", { enumerable: true, get: function () { return js_1.darkTheme; } });
//# sourceMappingURL=index.js.map